// src/components/layout/MainLayout.jsx
import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import ChatBubble from '../common/ChatBubble'; // ← tambahkan ini

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="min-h-screen">
        {children}
      </main>
      <Footer />
      <ChatBubble /> {/* ← tambahkan ini */}
    </div>
  );
};

export default MainLayout;